
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 15 15"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#070808","d":"M7.5 1.075A6.432 6.432 0 0113.925 7.5 6.432 6.432 0 017.5 13.925 6.433 6.433 0 011.075 7.5 6.433 6.433 0 017.5 1.075m0-1C3.399.075.075 3.399.075 7.5s3.324 7.425 7.425 7.425 7.425-3.324 7.425-7.425S11.601.075 7.5.075z"}}),_c('path',{attrs:{"fill":"#050606","d":"M8.19 7.483l2.622-2.623a.5.5 0 00-.707-.707L7.483 6.776 4.861 4.153a.5.5 0 00-.707.707l2.622 2.623-2.621 2.622a.5.5 0 00.708.707l2.62-2.622 2.621 2.621a.498.498 0 00.708 0 .5.5 0 000-.707L8.19 7.483z"}})])
          )
        }
      }
    